import { headerRegistry } from '../../shell/slots';
import { NotificationsBell } from './notifications/NotificationsBell';

/** Replaces the placeholder bell in the app header (also shown in the editor top bar). */
export function registerShell(): void {
  headerRegistry.register({ id: 'notifications', order: 10, component: NotificationsBell });
}

registerShell();
